import { Action, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  ChannelsPageAction,
  ChannelsPageState
} from "@/components/channelsPage/types";

export const actions: ActionTree<ChannelsPageState, RootState> &
  Record<ChannelsPageAction, Action<ChannelsPageState, RootState>> = {};
